<template>
  <v-form :value="valid" @input="v => $emit('update:valid', v)">
    <v-row align="center" dense>
      <v-col cols="12" sm="6">
        <j-date-picker
          :value="date"
          label=""
          icon=""
          required
          filled
          hide-details
          single-line
          dense
          @input="v => $emit('update:date', v)"
        ></j-date-picker>
      </v-col>
      <v-col>
        <v-select
          :value="time"
          :items="timeSelections"
          item-value="value"
          item-text="text"
          label=""
          icon=""
          required
          filled
          class="no-before"
          hide-details
          dense
          @input="v => $emit('update:time', v)"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row align="center" dense>
      <v-col cols="12" sm="12">
        <v-text-field
          filled
          class="no-before"
          label="Créé par"
          :value="author"
          hide-details
          dense
          single-line
          @change="v => $emit('update:author', v)"
          :rules="[
            v => !!v || 'Un nom est requis',
            v => v != '' || 'Un nom est requis',
            v => v != ' ' || 'Un nom est requis'
          ]"
        ></v-text-field>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import moment from "moment";
export default {
  name: "PreparationSlipFields",
  props: {
    author: {
      type: String,
      required: true
    },
    date: {
      required: true
    },
    time: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      timeSelections: [
        {
          value: 0,
          text: "Matin"
        },
        {
          value: 1,
          text: "Midi"
        },
        {
          value: 2,
          text: "Soir"
        }
      ]
    };
  },
  methods: {
    reset() {
      this.$refs.form.reset();
    }
  }
};
</script>

<style></style>
